/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-globals */
import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import Arrow from './arrow'
import Loader from './loader'

const StyledTable = styled.table`
  width: 100%;
  th {
    text-align: left;
    text-transform: uppercase;
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    a {
      color: #000;
    }
  }
  td {
    text-transform: uppercase;
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
    border-top: 1px solid #ddd;
    font-size: 14px;

    a {
      text-decoration: none;
      color: #148e9e;
    }
  }
  td:first-child {
  }
  td:last-child,
  th:last-child {
    text-align: right;
  }
`

const FilterBox = styled.input`
  padding: 10px;
  min-width: 300px;
  font-size: 14px;
`
const numberWithCommas = function(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const SortableHeader = styled.a`
  text-transform: uppercase;
  cursor: pointer;
`

const Table = ({ data, data: { defaultSort } }) => {
  const [sort, setSort] = useState(defaultSort)
  const [filter, setFilter] = useState('')
  const [filteredData, setFilteredData] = useState(data.data)
  const [total, setTotal] = useState()

  useEffect(() => {
    const _total = filteredData.reduce((prev, next) => prev + next.data, 0)
    setTotal(numberWithCommas(_total.toFixed(2)))
  }, [filteredData])

  useEffect(() => {
    const fd = data.data.filter(d =>
      Object.values(d).some(
        v =>
          v &&
          v
            .toString()
            .toLowerCase()
            .indexOf(filter.toLowerCase()) !== -1
      )
    )
    setFilteredData(fd)
  }, [data.data, filter])

  if (sort) {
    filteredData.sort((a, b) => {
      const first = sort.ascending ? a : b
      const second = sort.ascending ? b : a
      if (!isNaN(first[sort.field]))
        return first[sort.field] - second[sort.field]
      return first[sort.field].localeCompare(second[sort.field])
    })
  }
  return data.data.length === 0 ? (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>
      <Loader />
    </div>
  ) : (
    <StyledTable>
      <thead>
        <tr>
          <td colSpan="42" style={{ textAlign: 'right', borderTop: 'none' }}>
            <FilterBox
              placeholder="Filter Results"
              onChange={e => setFilter(e.target.value)}
            />
          </td>
        </tr>
        <tr>
          {data.headers.map((h, i) => (
            <th key={`header-${i}`}>
              <SortableHeader
                onClick={() => {
                  setSort({
                    field: h.dataKey,
                    ascending: !sort ? true : !sort.ascending
                  })
                }}
              >
                {h.title}
              </SortableHeader>
              {sort && sort.field === h.dataKey ? (
                <Arrow up={sort.ascending} />
              ) : null}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {filteredData.map((d, i) => (
          <tr key={`data-${i}`}>
            {data.headers.map((h, i2) => (
              <td
                key={`item-${i}-${i2}`}
                style={{
                  whiteSpace:
                    h.dataKey.toLowerCase().indexOf('date') !== -1
                      ? 'nowrap'
                      : undefined
                }}
              >
                {h.dataKey === 'data' ? (
                  `$${numberWithCommas(d[h.dataKey].toFixed(2))}`
                ) : h.clickThrough ? (
                  <a href={d[h.clickThrough]}>{d[h.dataKey]}</a>
                ) : (
                  d[h.dataKey]
                )}
              </td>
            ))}
          </tr>
        ))}
        <tr>
          <td colSpan={data.headers.length - 1}>
            <b>SUBTOTAL:</b>
          </td>
          <td>${total}</td>
        </tr>
      </tbody>
    </StyledTable>
  )
}

export default Table
